import { Link } from 'react-router-dom';

export default function OrderSuccessPage() {
  const orderId = `CH${Date.now().toString().slice(-8)}`;
  return (
    <section className="py-20 text-center">
      <div className="max-w-lg mx-auto px-5">
        <div className="w-24 h-24 rounded-full mx-auto mb-6 bg-emerald-400/15 border-2 border-emerald-400/30 flex items-center justify-center text-5xl">✓</div>
        <h2 className="section-title text-3xl mb-2">Order Placed Successfully!</h2>
        <div className="section-divider mb-6" />
        <p className="text-white/60 text-base leading-relaxed mb-8">
          Thank you for your order! Your sacred items will be blessed and shipped within 24 hours. You will receive a confirmation email shortly.
        </p>
        <div className="card-admin p-6 mb-8">
          <div className="text-xs text-white/40 mb-2">Order ID</div>
          <div className="text-2xl text-gold-500 font-bold font-display tracking-widest">#{orderId}</div>
        </div>
        <Link to="/shop" className="btn-primary no-underline">Continue Shopping</Link>
      </div>
    </section>
  );
}
